import React, { useEffect, useState } from 'react';
import { notification, Row, Transfer, Card } from 'antd';
import { useQuery } from 'react-query';
import { useTransfer } from '../../../../hooks/useTransfer';
import {
  MgOffer,
  getOfferListByCriteria,
  ParOfferListResponse,
} from '../../../../services/pricing';
import moment from 'moment';
import Title from 'components/Title';
import _ from 'lodash';
import {
  createBrokerParFiltering,
  getParValuesByBroker,
  removeBrokerParFiltering,
} from 'services/parametersService';

type OfferTransferProps = {
  mgid: number;
  tpidbroker: number;
};

const BrokerOfferTransfer = ({ ...props }: OfferTransferProps) => {
  const { onSelectChange, selectedKeys } = useTransfer();
  let displayNotification = true;
  const [offersList, setOfferList] = useState<ParOfferListResponse[]>();

  const { mgid, tpidbroker } = props;

  const { data: prList } = useQuery(['getOfferListByCriteria', mgid], () =>
    getOfferListByCriteria({
      duration: 0,
      finamount: 0,
      prcode: '',
      mgid: mgid,
      status: '',
    })
      .then((res) => res.list || [])
      .catch((res) => [])
  );

  const { data: prListAssociated, refetch: ref } = useQuery(
    [
      'getParValuesByBroker',
      {
        mgid: mgid,
        parcode: 'OFFER',
        tpidbroker: tpidbroker,
      },
    ],
    () =>
      getParValuesByBroker({
        mgid: mgid,
        parcode: 'OFFER',
        tpidbroker: tpidbroker,
      })
        .then((res) => res.list || [])
        .catch((res) => [])
  );

  useEffect(() => {
    if (!_.isNil(prListAssociated) && !_.isNil(prList)) {
      setOfferList(prList);
    }
  }, [prListAssociated, prList, offersList]);
  const onChange = (
    targetKeys: string[],
    direction: string,
    moveKeys: string[]
  ) => {
    if (direction === 'left') {
      // eslint-disable-next-line array-callback-return
      moveKeys.forEach((key) => {
        let parlist = prListAssociated?.find(
          (parlist) => parlist.parvalue === key 
        );
        removeBrokerParFiltering({
          filterid: parlist?.filterid ?? 0,
          tpidbroker: tpidbroker,
        }).then((res) => {
          if (res.code === '200') {
            ref();
            notification.success({
              message: res.message,
            });
          }
        });
      });
    } else {
      // eslint-disable-next-line array-callback-return
      moveKeys.forEach((key) => {
        const mgOffersrequest: MgOffer = {
          enddate: '',
          startdate: moment(Date.now()).format('YYYY-MM-DD'),
          mgOfferpk: { mgid: mgid, offerid: Number(key) },
        };

        createBrokerParFiltering({
          request: {
            filterid: 0,
            flagdefault: false,
            mgid: mgid,
            parcode: 'OFFER',
            parvalue: key,
            tpidbroker: tpidbroker,
          },
          tpidbroker: tpidbroker,
        }).then((res) => {
          if (res.code === '200') {
            ref();
            notification.success({
              message: res.message,
            });
          }
        });
      });
    }
  };

  return (
    <div>
      <Card
        title={<Title level={4} comcode="offerCompany"></Title>}
        size="small"
      >
        <Row>
          <Transfer
            style={{ width: '100%' }}
            dataSource={prList ? prList : []}
            showSearch
            targetKeys={
              prListAssociated?.map((offer) => String(offer.parvalue)) ?? []
            }
            onChange={onChange}
            selectedKeys={selectedKeys}
            onSelectChange={onSelectChange}
            titles={['availableValues', 'associatedValues']}
            render={(pr) => pr.offerlabel}
            rowKey={(pr) => String(pr.offerid)}
            listStyle={{
              width: '100%',
              height: 300,
            }}
          />
        </Row>
      </Card>
    </div>
  );
};

export default BrokerOfferTransfer;
